import type { FC } from 'react';

import AnalyticsMetrics from '@/features/analytics/components/AnalyticsMetrics';
import CoinEconomyCard from '@/features/analytics/components/CoinEconomyCard';
import OnboardingFunnelCard from '@/features/analytics/components/OnboardingFunnelCard';
import PeakHoursCard from '@/features/analytics/components/PeakHoursCard';
import TopCategoriesCard from '@/features/analytics/components/TopCategoriesCard';
import { useAnalyticsPage } from '@/features/analytics/hooks/useAnalyticsPage.hook';

const AnalyticsPage: FC = () => {
  const vm = useAnalyticsPage();

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-[22px] font-extrabold tracking-tight text-[var(--color-ink)]">
          Reports &amp; Analytics
        </h1>
        <p className="mt-1 text-[13px] text-[var(--color-ink-muted)]">
          Deep insights across signups, rentals and the coin economy
        </p>
      </header>

      {vm.isLoading ? (
        <div className="rounded-2xl border border-[var(--color-divider)] bg-white p-10 text-center text-[13px] text-[var(--color-ink-muted)] shadow-[var(--shadow-card)]">
          Loading analytics…
        </div>
      ) : vm.isError || !vm.analytics ? (
        <div className="rounded-2xl border border-[var(--color-divider)] bg-white p-10 text-center shadow-[var(--shadow-card)]">
          <p className="text-[14px] font-semibold text-[var(--color-ink)]">
            Couldn&rsquo;t load analytics
          </p>
          <p className="mt-1 text-[13px] text-[var(--color-ink-muted)]">
            {vm.errorMessage ?? 'Please try again.'}
          </p>
        </div>
      ) : (
        <>
          <AnalyticsMetrics analytics={vm.analytics} />

          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            <TopCategoriesCard categories={vm.analytics.topCategories} />
            <PeakHoursCard hours={vm.analytics.peakHours} />
            <OnboardingFunnelCard funnel={vm.analytics.funnel} />
            <CoinEconomyCard economy={vm.analytics.coinEconomy} />
          </div>
        </>
      )}
    </div>
  );
};

export default AnalyticsPage;
